import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import Contact from "@/components/site/Contact";

export default function ContactPage() {
    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <>
            <Navigation />

            {/* Slim intro bar */}
            <section
                data-testid="kontakt-page-hero"
                className="relative pt-32 lg:pt-40 pb-8 lg:pb-12 bg-[#FEFEFE]"
            >
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <Link
                        to="/"
                        data-testid="kontakt-back-link"
                        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-[#14100D]/60 hover:text-[#E20514] transition-colors"
                    >
                        <ArrowLeft size={14} /> Zurück zur Startseite
                    </Link>
                </div>
            </section>

            <Contact />

            <Footer />
        </>
    );
}
